import { Routes } from '@angular/router';

import { ERoutes, UtilityRoutes } from '../../types/app-routes';
import { CardCanDeactivateGuard } from '../../services/card-can-deactivate-guard.service';

export const npaRoutes: Routes = [
  {
    path: ERoutes.NPA,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./npa-table/npa-table.component').then((m) => m.NpaTableComponent),
      },
      {
        path: UtilityRoutes.CARD,
        canDeactivate: [CardCanDeactivateGuard],
        loadComponent: () =>
          import('./npa-card/npa-card.component').then((m) => m.NpaCardComponent),
      },
    ],
  },
];
